import _ from 'lodash'
import type { Spx } from '@wix/thunderbolt-becky-types'
import { StylePropItem } from '@wix/thunderbolt-becky-root'
import { atomicStylePropsConverterMap } from '../atomics/atomicPropsToCss'
import { fontConverterMap } from '../compositions/Font/fontPropsToCss'
import { mathConverterMap } from '../compositions/MathFunction/mathPropsToCss'
import { colorConverterMap } from '../compositions/Color/colorPropsToCss'
import { borderConverterMap } from '../compositions/Border/borderPropsToCss'
import { textDecorationConverterMap } from '../compositions/TextDecoration/textDecorationPropsToCss'
import { genericsConverterMap } from '../generics/genericsPropsToCss'
import { shadowConverterMap } from '../compositions/Shadow/shadowPropsToCss'
import { backgroundConverterMap } from '../compositions/Background/backgroundPropsToCss'
import { alignSelfConverterMap } from '../compositions/AlignSelf/alignSelfPropsToCss'

export const stylePropsToCssConverterMap: Record<
	string,
	(styleProp: StylePropItem, spx: Spx) => Record<string, string> | string
> = _.mergeWith(
	{
		...atomicStylePropsConverterMap,
	},
	{ ...genericsConverterMap },
	{ ...mathConverterMap },
	{ ...colorConverterMap },
	{ ...fontConverterMap },
	{ ...borderConverterMap },
	{ ...textDecorationConverterMap },
	{ ...shadowConverterMap },
	{ ...backgroundConverterMap },
	{ ...alignSelfConverterMap }
)

export const convertStyleProp = (styleProp: StylePropItem, propName: string, spx: Spx): Record<string, string> => {
	const cssProps = stylePropsToCssConverterMap[styleProp.type](styleProp, spx)

	if (typeof cssProps === 'string') {
		return { [`--${propName}`]: cssProps }
	}

	const cssVars: Record<string, string> = {}
	Object.entries(cssProps).forEach(([key, subpropValue]) => {
		if (subpropValue) {
			if (key === styleProp.type) {
				cssVars[`--${propName}`] = subpropValue.replaceAll(`{propName}`, propName)
			} else {
				cssVars[`--${propName}-${key}`] = subpropValue
			}
		}
	})

	return cssVars
}
